export default __webpack_public_path__ + "static/media/HighlightImage.d9c127b4.jpg";